export const CareersPage = () => {
  return (
    <div className="mx-auto max-w-7xl space-y-16 px-6 pb-20 pt-16 md:px-10">

      {/* HERO */}
      <section>
        <p className="text-sm uppercase tracking-[0.2em] text-[#6FE3C1]">
          Careers
        </p>

        <h1 className="mt-4 text-4xl font-bold md:text-5xl">
          Build the Future of AI-Driven Hiring
        </h1>

        <p className="mt-6 max-w-3xl text-[#D9E1E8]/80 text-lg">
          At The AI Matters, we’re building the infrastructure that powers
          modern hiring organizations. Our platform combines artificial
          intelligence, recruiter networks, and structured hiring workflows
          to transform how companies discover and evaluate talent.
        </p>
      </section>


      {/* CULTURE */}
      <section className="grid gap-8 md:grid-cols-2">

        <div className="glass-panel rounded-2xl p-8">
          <h2 className="text-2xl font-bold mb-4">
            Our Culture
          </h2>

          <p className="text-[#D9E1E8]/80">
            We believe innovation happens when talented people are given the
            freedom to experiment, collaborate, and solve meaningful
            problems. Our team is focused on building technology that
            fundamentally improves how companies hire.
          </p>

          <p className="mt-4 text-[#D9E1E8]/80">
            At The AI Matters, we encourage curiosity, ownership, and
            long-term thinking. Every team member contributes directly to
            shaping the future of hiring infrastructure.
          </p>
        </div>


        <div className="glass-panel rounded-2xl p-8">
          <h2 className="text-2xl font-bold mb-4">
            Why Join Us
          </h2>

          <ul className="space-y-3 text-[#D9E1E8]/80">
            <li>• Work on cutting-edge AI and hiring technology</li>
            <li>• Help build a next-generation SaaS platform</li>
            <li>• Collaborate with a global network of recruiters</li>
            <li>• Solve real-world hiring challenges for companies</li>
            <li>• Be part of a fast-growing technology startup</li>
          </ul>
        </div>

      </section>


      {/* BENEFITS */}
      <section>

        <h2 className="text-3xl font-bold mb-8">
          What We Offer
        </h2>

        <div className="grid gap-6 md:grid-cols-3">

          <div className="glass-panel rounded-xl p-6">
            <h3 className="text-xl font-semibold mb-2">
              Meaningful Work
            </h3>
            <p className="text-[#D9E1E8]/80">
              Build technology that impacts how organizations hire and
              grow their teams.
            </p>
          </div>

          <div className="glass-panel rounded-xl p-6">
            <h3 className="text-xl font-semibold mb-2">
              Learning & Growth
            </h3>
            <p className="text-[#D9E1E8]/80">
              Work with talented people while continuously improving your
              skills in AI, product development, and SaaS platforms.
            </p>
          </div>

          <div className="glass-panel rounded-xl p-6">
            <h3 className="text-xl font-semibold mb-2">
              Innovation Culture
            </h3>
            <p className="text-[#D9E1E8]/80">
              We value creativity, experimentation, and new ideas that
              push the boundaries of hiring technology.
            </p>
          </div>

        </div>

      </section>


      {/* HIRING PROCESS */}
      <section className="glass-panel rounded-2xl p-10 text-center">

        <h2 className="text-3xl font-bold mb-4">
          Interested in Joining Us?
        </h2>

        <p className="max-w-2xl mx-auto text-[#D9E1E8]/80 mb-6">
          We are always looking for talented individuals who want to help
          transform the hiring industry through technology and AI.
        </p>

        <p className="text-[#D9E1E8]/80">
          Reach out through our contact page to explore current and
          upcoming opportunities.
        </p>

      </section>

    </div>
  );
};